import React, { useState, useEffect, memo } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import {
  saveMenuMutation,
  menuListByFilterQuery,
  copyMenuItems,
  loadMenuFormWrapper,
  saveMealMutation,
} from '../../../shared/queries/Menu';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import { upLoadFile } from '../../../shared/utils/smartutils';
import SmartCard from '../../../shared/components/SmartCard';
import GraphQL from '../../../GraphQL';
import Form from './Form';
import Modal from '../../../shared/components/Modal';
import menuStudentListByMenuId from '../../../shared/queries/MenuStudentRelation';

const FormHandler = (props) => {
  const { match, t, history, dispatch } = props;

  const [meal, setMeal] = useState({});
  const [formOn, setForm] = useState(false);
  const [selectedStudents, setSelectStudent] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [unsavedItems, setUnsavedItems] = useState(false);
  const [saveMealModal, setSaveMealModal] = useState(false);
  const [editField, setEditField] = useState({ status: false, field: '' });
  const [studentsToSelect, setUnSelectStudent] = useState([]);
  const [menuItemsWrapper, setMenuItems] = useState({
    meals: [],
    menuColumns: [],
  });
  const [dto, setDto] = useState({
    id: 0,
    active: true,
    inDetail: true,
  });

  const toggleEditField = (values) => {
    if (values) {
      setEditField({ status: true, field: values.name, ...values });
      setMeal(values);
    } else if (editField.status) {
      setEditField({ status: false, field: '' });
    }
  };

  const toggleSaveMealModal = () => {
    setSaveMealModal(!saveMealModal);
  };

  const backClickHandler = () => {
    history.push('/minime/cardapio');
  };

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const updateMenuItems = (menuItems, changed) => {
    dispatch(change('MenuForm', 'menuItems', menuItems));
    setUnsavedItems(changed);
  };

  const updateRelatedStudents = (relatedStudents) => {
    dispatch(change('MenuForm', 'students', relatedStudents));
  };

  const loadStudents = (menuId, showOnlyRelated) => {
    const query = menuStudentListByMenuId(menuId, showOnlyRelated);
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        if (showOnlyRelated) {
          setSelectStudent(res.menuStudentListByMenuId);
          updateRelatedStudents(res.menuStudentListByMenuId);
        } else {
          setUnSelectStudent(res.menuStudentListByMenuId);
        }
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('repeat-menu.errors.repeat-items')
        );
        hideLoading();
      });
  };

  const loadMenuItems = (menuId, date) => {
    showLoading();
    const referenceDate = date
      ? new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0)
      : new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate(),
          0,
          0,
          0
        );
    const query = loadMenuFormWrapper(menuId, referenceDate.getTime());
    GraphQL(query, {})
      .then((resp) => {
        if (editField) {
          toggleEditField();
        }
        setMenuItems(resp.loadMenuFormWrapper);
        updateMenuItems(resp.loadMenuFormWrapper, false);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-remove')
        );
      });
  };

  const saveMeal = () => {
    toggleSaveMealModal();
    const mutation = saveMealMutation(meal);
    showLoading();
    GraphQL(mutation, {})
      .then(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
        loadMenuItems(dto.id, selectedDate);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-save')
        );
      });
  };

  const findById = (id) => {
    showLoading();
    const filter = {
      id: parseInt(id, 10),
      active: false,
      inDetail: false,
      studentQuantity: 0,
      deleted: false,
      filterByStatus: false,
      updaterId: 0,
    };
    const query = menuListByFilterQuery(filter);
    GraphQL(query, {})
      .then((res) => {
        if (res.menuListByFilter && res.menuListByFilter.length > 0) {
          setDto({
            ...res.menuListByFilter[0],
          });
          loadMenuItems(res.menuListByFilter[0].id, selectedDate);
          loadStudents(res.menuListByFilter[0].id, false);
          loadStudents(res.menuListByFilter[0].id, true);
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.find-record-error')
          );
          backClickHandler();
        }
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.find-record-error')
        );
        backClickHandler();
      });
  };

  const saveMenu = (values, uploadedFile) => {
    const mutation = saveMenuMutation(values, uploadedFile);
    GraphQL(mutation, {})
      .then((res) => {
        const { id } = res.menuSave;
        hideLoading();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
        history.push(`/minime/cardapio/mnt/${id}`);
        findById(id);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-save')
        );
      });
  };

  const handleSubmit = async (values) => {
    showLoading();
    let uploadedFile;
    if (!values.inDetail) {
      if (values.files) {
        if (values.files.length === 1) {
          if (!values.files[0].fileId) {
            uploadedFile = await upLoadFile(values.files[0]);
          } else {
            uploadedFile = { fileId: dto.fileId };
          }
        } else {
          uploadedFile = { fileId: '' };
        }
        saveMenu(values, uploadedFile);
      } else if (!values.files && !values.inDetail) {
        hideLoading();
        showNotificationAutoDestroy(
          'warning',
          t('notifications.attention'),
          t('notifications.warning-menu-no-file')
        );
      }
    } else {
      saveMenu(values);
    }
  };

  const repeatItemsSubmitHandler = (
    refDate,
    initialDate,
    finalDate,
    menuId
  ) => {
    showLoading();
    const mutation = copyMenuItems(refDate, initialDate, finalDate, menuId);
    GraphQL(mutation, {})
      .then(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('repeat-menu.success.repeat-items')
        );
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('repeat-menu.errors.repeat-items')
        );
      });
  };

  const changeSelectedDate = (date) => {
    setSelectedDate(date);
    loadMenuItems(dto.id, date);
  };

  const loadDataForm = () => {
    loadMenuItems(dto.id, selectedDate);
    loadStudents(dto.id, false);
    loadStudents(dto.id, true);
    setForm(true);
  };

  useEffect(() => {
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        findById(match.params.id);
      } else {
        setForm(true);
      }
    } else {
      loadDataForm();
    }
  }, [dto]);

  return (
    <SmartCard title={t('panels.cardapio')}>
      {formOn ? (
        <>
          <Modal
            color="warning"
            title={t('notifications.attention')}
            btn="warning"
            message={t('notifications.change-meal-replicated-menus')}
            toggle={toggleSaveMealModal}
            modal={saveMealModal}
            onConfirm={saveMeal}
          />
          <Form
            onSubmit={handleSubmit}
            repeatItemsSubmitHandler={repeatItemsSubmitHandler}
            backHandler={backClickHandler}
            dto={dto}
            menuItemsWrapper={menuItemsWrapper}
            unsavedItems={unsavedItems}
            setUnsavedItems={setUnsavedItems}
            selectedDate={selectedDate}
            changeSelectedDate={changeSelectedDate}
            toggleSaveMealModal={toggleSaveMealModal}
            editField={editField}
            meal={meal}
            toggleEditField={toggleEditField}
            updateMenuItems={updateMenuItems}
            setMeal={setMeal}
            updateRelatedStudents={updateRelatedStudents}
            selectedStudents={selectedStudents}
            setSelectStudent={setSelectStudent}
            studentsToSelect={studentsToSelect}
            setUnSelectStudent={setUnSelectStudent}
          />
        </>
      ) : null}
    </SmartCard>
  );
};

FormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(memo(FormHandler))
);
